import { useEffect, useState } from "react";
import Flow from "../../../../Assets/Images/Flow.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import "../Reports.scss";
import { applyFullTieOrder } from "../../../../utils/quadrantTieOrder";

export default function YourQuardrantsFlow({ apiData, pageNumber, reportType }) {

  const [highestStarter, setHighestStarter] = useState('')
  const [mostSelecTedStarter, setMostSelecTedStarter] = useState('')
  const [secondMostSelecTedStarter, setSecondMostSelecTedStarter] = useState('')
  const [snapshotResult, setSnapshotResults] = useState([])
  const [starterLabel, setStarterLabel] = useState([])

  const [variablsMapArray, setVariableMapArray] = useState()
  const [scoreRanking, setScoreRanking] = useState([])

  const pairs = [
    { round1: "heart_round1_m", round2: "heart_round2_m" },
    { round1: "soul_round1_m", round2: "soul_round2_m" },
    { round1: "str_round1_m", round2: "str_round2_m" },
    { round1: "mind_round1_m", round2: "mind_round2_m" }
  ];

  const variableMap = apiData?.variables?.reduce((acc, el) => {
    acc[el.variable] = el.score;
    return acc;
  }, {});
  useEffect(() => {
    if (variableMap) {
      setVariableMapArray(variableMap);
    }
  }, [apiData]);

  useEffect(() => {
    let highestScore = -Infinity;
    let highestVariable = "";
    let results = [];
    let labelsArray = [];

    if (variablsMapArray) {
      const heart_r1_m = variablsMapArray["heart_round1_m"] || 0;
      const soul_r1_m = variablsMapArray["soul_round1_m"] || 0;
      const mind_r1_m = variablsMapArray["mind_round1_m"] || 0;
      const strength_r1_m = variablsMapArray["str_round1_m"] || 0;

      const heart_r2_m = variablsMapArray["heart_round2_m"] || 0;
      const soul_r2_m = variablsMapArray["soul_round2_m"] || 0;
      const mind_r2_m = variablsMapArray["mind_round2_m"] || 0;
      const strength_r2_m = variablsMapArray["str_round2_m"] || 0;

      const heart_r1_l = variablsMapArray["heart_round1_l"] || 0;
      const soul_r1_l = variablsMapArray["soul_round1_l"] || 0;
      const mind_r1_l = variablsMapArray["mind_round1_l"] || 0;
      const strength_r1_l = variablsMapArray["str_round1_l"] || 0;

      const heart_r2_l = variablsMapArray["heart_round2_l"] || 0;
      const soul_r2_l = variablsMapArray["soul_round2_l"] || 0;
      const mind_r2_l = variablsMapArray["mind_round2_l"] || 0;
      const strength_r2_l = variablsMapArray["str_round2_l"] || 0;

      const heart_highest = Math.max(heart_r1_m, heart_r2_m, heart_r1_l, heart_r2_l);
      const mind_highest = Math.max(mind_r1_m, mind_r2_m, mind_r1_l, mind_r2_l);
      const soul_highest = Math.max(soul_r1_m, soul_r2_m, soul_r1_l, soul_r2_l);
      const strength_highest = Math.max(strength_r1_m, strength_r2_m, strength_r1_l, strength_r2_l);

      // let testingVarsM2 = [heart_r2 + heart_r1_m, soul_r2 + soul_round1_m, mind_r2 + mind_round1_m, strength_r2 + strength_round1_m];
      let testingVarsM2Pair = [{ "name": "heart", "score": heart_highest }, { "name": "soul", "score": soul_highest }, { "name": "mind", "score": mind_highest }, { "name": "strength", "score": strength_highest }];

      highestVariable = testingVarsM2Pair.reduce((max, current) =>
        current.score > max.score ? current : max, { name: "", score: -Infinity }
      );


      let most_score = Math.max(heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m)
      // let second_most_score = Math.max(heart_r2_m,soul_r2_m,mind_r2_m,strength_r2_m) / 2
      // let least_score = Math.max(heart_r1_l,soul_r1_l,mind_r1_l,strength_r1_l)
      // let second_least_score = Math.max(heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l) / 2

      const secondMostRawScoreMap = {
        Heart: heart_r2_m,
        Soul: soul_r2_m,
        Mind: mind_r2_m,
        Strength: strength_r2_m
      };
      const secondLeastRawScoreMap = {
        Heart: heart_r2_l,
        Soul: soul_r2_l,
        Mind: mind_r2_l,
        Strength: strength_r2_l
      };
      const mostScoreMap = {
        Heart: heart_r1_m,
        Soul: soul_r1_m,
        Mind: mind_r1_m,
        Strength: strength_r1_m
      };
      const leastScoreMap = {
        Heart: heart_r1_l,
        Soul: soul_r1_l,
        Mind: mind_r1_l,
        Strength: strength_r1_l
      };

      const raw_second_most_score = Math.max(...Object.values(secondMostRawScoreMap));
      const raw_second_least_score = Math.max(...Object.values(secondLeastRawScoreMap));

      let second_most_score = raw_second_most_score / 2;
      let least_score = Math.max(...Object.values(leastScoreMap));
      let second_least_score = raw_second_least_score / 2;

      if (least_score >= second_least_score) {
        least_score = second_least_score - 1;
      }

      // Fix label mapping by using lowercase and handling duplicates properly
      const findLabelForScore = (scoreMap, targetScore, excludeLabels = []) => {
        const foundKey = Object.keys(scoreMap).find(key =>
          scoreMap[key] === targetScore && !excludeLabels.includes(key.toLowerCase())
        );
        return foundKey ? foundKey.toLowerCase() : null;
      };

      let most_scored_label = findLabelForScore(mostScoreMap, most_score);
      let second_most_scored_label = findLabelForScore(secondMostRawScoreMap, raw_second_most_score, [most_scored_label]);
      let least_scored_label = findLabelForScore(leastScoreMap, least_score, [most_scored_label, second_most_scored_label]);
      let second_least_scored_label = findLabelForScore(secondLeastRawScoreMap, raw_second_least_score, [most_scored_label, second_most_scored_label, least_scored_label]);

      // Fallback logic if any label is null/undefined
      const allLabels = ['heart', 'soul', 'mind', 'strength'];
      const usedLabels = [most_scored_label, second_most_scored_label, least_scored_label, second_least_scored_label].filter(Boolean);

      if (!most_scored_label) most_scored_label = allLabels.find(label => !usedLabels.includes(label)) || 'heart';
      if (!second_most_scored_label) second_most_scored_label = allLabels.find(label => !usedLabels.includes(label)) || 'soul';
      if (!least_scored_label) least_scored_label = allLabels.find(label => !usedLabels.includes(label)) || 'mind';
      if (!second_least_scored_label) second_least_scored_label = allLabels.find(label => !usedLabels.includes(label)) || 'strength';

      if (least_score >= second_least_score) {
        least_score = (second_least_score - 1)
      }

      const total = most_score + second_most_score + least_score + second_least_score;

      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100

      let labels = testingVarsM2Pair.map(item => item.name);

      const labels_arr = ["heart", "soul", "mind", "strength"];

      const mostValues = [heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m];
      const secondMostValues = [heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m];
      const leastValues = [heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l];
      const secondLeastValues = [heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l];

      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);

      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];

      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label);

      const getPercentageOrder = (label) => {
        if (label == most_label?.toLowerCase()) {
          return most_per;
        }
        if (label == second_most_label?.toLowerCase()) {
          return second_most_per;
        }
        if (label == least_label?.toLowerCase()) {
          return least_per;
        }
        if (label == second_least_label?.toLowerCase()) {
          return second_least_per;
        }

        return 0
      }

      // Create a direct mapping of labels to their calculated percentages
      const directPercentageMap = {
        'mind': getPercentageOrder("mind"),
        'soul': getPercentageOrder("soul"),
        'strength': getPercentageOrder("strength"),
        'heart': getPercentageOrder("heart")
      };

      // Set results array to match the fixed label order
      results = [
        directPercentageMap['mind'],
        directPercentageMap['soul'],
        directPercentageMap['strength'],
        directPercentageMap['heart']
      ];

      labelsArray = ['mind', 'soul', 'strength', 'heart'];

      // Create RankedScores based on the direct percentage mapping
      const RankedScores = [
        { name: 'mind', value: directPercentageMap['mind'] },
        { name: 'soul', value: directPercentageMap['soul'] },
        { name: 'strength', value: directPercentageMap['strength'] },
        { name: 'heart', value: directPercentageMap['heart'] }
      ];

      // Sort from highest to lowest percentage
      RankedScores.sort((a, b) => b.value - a.value);

      // console.log('RankedScores before setting:', RankedScores)

      setScoreRanking(RankedScores)

      // console.log('highestVariable', highestVariable)
      // console.log("pie chart results", results);
      // console.log("pie chart labelsArray", labelsArray);

      setHighestStarter(most_label);
      // setStarterScore(most_per);
      setSnapshotResults(results);
      setStarterLabel(labelsArray);
      getMostAndSecondMostVaribale(apiData)
    }

  }, [variablsMapArray]);

  const getMostAndSecondMostVaribale = () => {
    if (apiData?.variables?.length > 0) {
      const extractCoreVariable = (variable) =>
        variable?.split("_")[0];

      const highestRound1Variable = pairs
        ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round1))
        ?.filter(Boolean)
        ?.reduce((highest, current) => (current?.score > highest?.score ? current : highest), { score: -Infinity });

      const highestRound2Variable = pairs
        ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round2))
        ?.filter(Boolean)
        ?.reduce((highest, current) => (current?.score > highest?.score ? current : highest), { score: -Infinity });

      const coreRound1 = extractCoreVariable(highestRound1Variable?.variable);
      const coreRound2 = extractCoreVariable(highestRound2Variable?.variable);

      if (coreRound1 === coreRound2) {
        const secondHighestRound1Variable = pairs
          ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round1))
          ?.filter(Boolean)
          ?.sort((a, b) => b?.score - a?.score)
          ?.find((v) => v?.variable !== highestRound1Variable?.variable);

        setMostSelecTedStarter(highestRound1Variable?.variable || null);
        setSecondMostSelecTedStarter(secondHighestRound1Variable?.variable || null);
      } else {
        setMostSelecTedStarter(highestRound1Variable?.variable || null);
        setSecondMostSelecTedStarter(highestRound2Variable?.variable || null);
      }
    }
  }

  const sortedScores = [...scoreRanking].sort((a, b) => b.value - a.value);

  // console.log('scoreRanking-new', scoreRanking)

  const sortedAndRoundedArray = [...snapshotResult]
    .sort((a, b) => b - a)
    .map(value => Math.round(value));


  // console.log('resultString', sortedAndRoundedArray)

  const SquareWithArrow = () => {

    const topLeft = 'MIND';
    const topRight = 'STRENGTH';
    const bottomLeft = 'SOUL';
    const bottomRight = 'HEART';

    const topLeftValue = (scoreRanking.find(s => s.name === 'mind')?.value || 0).toFixed(2);
    const topRightValue = (scoreRanking.find(s => s.name === 'strength')?.value || 0).toFixed(2);
    const bottomLeftValue = (scoreRanking.find(s => s.name === 'soul')?.value || 0).toFixed(2);
    const bottomRightValue = (scoreRanking.find(s => s.name === 'heart')?.value || 0).toFixed(2);

    const labelStyle = { color: '#000', fontSize: '10px', fontWeight: '700', fontFamily: 'Helvetica, sans-serif', textTransform: 'uppercase', position: 'absolute', lineHeight: '1.2' };

    const percentageStyle = { color: '#000', fontSize: '10px', fontWeight: '700', fontFamily: 'Helvetica, sans-serif', position: 'absolute', lineHeight: '1.2' };

  
    const diagramSize = 206;
    const headLength = 14;
    const headWidth = 8;
    const centerOffsetX = diagramSize / 2;
    const centerOffsetY = diagramSize / 2;
    const quadrantOffsetX = centerOffsetX / 2;
    const quadrantOffsetY = centerOffsetY / 2;

    const quadrantCenters = {
      mind: { x: quadrantOffsetX, y: quadrantOffsetY },
      strength: { x: diagramSize - quadrantOffsetX, y: quadrantOffsetY },
      soul: { x: quadrantOffsetX, y: diagramSize - quadrantOffsetY },
      heart: { x: diagramSize - quadrantOffsetX, y: diagramSize - quadrantOffsetY }
    };

    // Get scores for each quadrant
    const quadrantScores = [
      { name: 'mind', score: scoreRanking.find(s => s.name === 'mind')?.value || 0 },
      { name: 'strength', score: scoreRanking.find(s => s.name === 'strength')?.value || 0 },
      { name: 'soul', score: scoreRanking.find(s => s.name === 'soul')?.value || 0 },
      { name: 'heart', score: scoreRanking.find(s => s.name === 'heart')?.value || 0 }
    ];

    const sortedQuadrants = applyFullTieOrder(
      [...quadrantScores].sort((a, b) => b.score - a.score),
      (q) => q.name,
      (q) => q.score
    )
      .map(({ name, score }) => ({
        name: name.charAt(0).toUpperCase() + name.slice(1),
        value: score
      }));


  const pathPoints = sortedQuadrants.map(step => quadrantCenters[step.name.toLowerCase()]);

   

    let arrowPath = '';
    if (pathPoints.length > 0) {
      const pointsForPath = [...pathPoints];
      if (pointsForPath.length > 1) {
        const tip = pointsForPath[pointsForPath.length - 1];
        const prev = pointsForPath[pointsForPath.length - 2];
        const dx = tip.x - prev.x;
        const dy = tip.y - prev.y;
        const len = Math.hypot(dx, dy) || 1;
        const trimmedTip = {
          x: tip.x - (headLength * dx) / len,
          y: tip.y - (headLength * dy) / len
        };
        pointsForPath[pointsForPath.length - 1] = trimmedTip;
      }

      arrowPath = `M ${pointsForPath[0].x} ${pointsForPath[0].y}`;
      for (let i = 1; i < pointsForPath.length; i++) {
        arrowPath += ` L ${pointsForPath[i].x} ${pointsForPath[i].y}`;
      }
    }

    const dotPosition = sortedQuadrants[0] ?
      quadrantCenters[sortedQuadrants[0].name.toLowerCase()] :
      { x: 0, y: 0 };

    const arrowColor = '#B6111F';
    let arrowHeadPoints = '';



    if (sortedQuadrants.length > 1) {
      const lastIdx = sortedQuadrants?.length - 1;
      const tip = quadrantCenters[sortedQuadrants[lastIdx].name.toLowerCase()];
      const prev = quadrantCenters[sortedQuadrants[lastIdx - 1].name.toLowerCase()];
      const angle = Math.atan2(tip.y - prev.y, tip.x - prev.x);
      const left = {
        x: tip.x - headLength * Math.cos(angle) + headWidth * Math.sin(angle),
        y: tip.y - headLength * Math.sin(angle) - headWidth * Math.cos(angle)
      };
      const right = {
        x: tip.x - headLength * Math.cos(angle) - headWidth * Math.sin(angle),
        y: tip.y - headLength * Math.sin(angle) + headWidth * Math.cos(angle)
      };
      arrowHeadPoints = `${tip.x},${tip.y} ${left.x},${left.y} ${right.x},${right.y}`;
    }

    return (
      <div style={{ position: 'relative', width: '206px', height: '206px', backgroundColor: 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px solid #000' }}>
        <div style={{ ...labelStyle, top: '6px', left: '10px' }}>
          {topLeft}
        </div>

        <div style={{ ...labelStyle, top: '6px', right: '10px' }}>
          {topRight}
        </div>

        <div style={{ ...percentageStyle, top: '20px', left: '10px' }}>
          {topLeftValue}%
        </div>

        <div style={{ ...percentageStyle, top: '20px', right: '10px' }}>
          {topRightValue}%
        </div>

        <div style={{ ...percentageStyle, bottom: '23px', left: '10px' }}>
          {bottomLeftValue}%
        </div>
        <div style={{ ...labelStyle, bottom: '10px', left: '10px' }}>
          {bottomLeft}
        </div>

        <div style={{ ...percentageStyle, bottom: '23px', right: '10px' }}>
          {bottomRightValue}%
        </div>
        <div style={{ ...labelStyle, bottom: '10px', right: '10px' }}>
          {bottomRight}
        </div>

        {/* Vertical divider */}
        <div style={{ position: 'absolute', width: '2px', height: '100%', backgroundColor: '#000' }}></div>

        {/* Horizontal divider */}
        <div style={{ position: 'absolute', width: '100%', height: '2px', backgroundColor: '#000' }}></div>

        <svg width={diagramSize} height={diagramSize} style={{ position: 'absolute', top: 0, left: 0 }}>
          <circle cx={dotPosition.x} cy={dotPosition.y} r="8" fill={arrowColor} />
          <path
            d={arrowPath}
            stroke={arrowColor}
            strokeWidth="4"
            strokeOpacity="1"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          {arrowHeadPoints && (
            <polygon points={arrowHeadPoints} fill={arrowColor} stroke={arrowColor} />
          )}
        </svg>
      </div>
    );
  }

  return (
    <div>
      <HeaderPreview apiData={apiData} />
      <div className="quadrant-flow-container">
        <div className="about-report-section">
          <div className="content-wrapper">
            <div className="text-content">
              <h2 className="section-title">FLOW TYPE™</h2>
              <span className="subtitle">How You Move Through the Quadrants</span>
              <p>Alright, we have identified your Starter Quadrant, your home base. The moment you shift from that starting point, your Flow Type™ begins to emerge. The second quadrant you move into adds important nuance. Two people can share the same starting point yet operate very differently depending on where they go next.</p>
              <p>Some move from emotion to action. Others flow from vision to planning. The sequence shapes how you lead, relate, and respond under pressure.</p>
              <p>There are many possible Flow combinations based on how your energy moves through the quadrants. You do not need to memorize them. We focus on your specific pattern of four. The goal is to notice your natural rhythm, recognize your default patterns, and pay attention to the parts of you that tend to be overlooked or underused.</p>
              <p>Your last quadrant, the one you move into least, is often a blind spot or stretch area. It is not always a weakness. It is an invitation to recover a part of yourself that has gone quiet. Reclaiming that space often creates a deeper sense of integration.</p>
              <p>When you learn to move through all four quadrants of Heart, Soul, Mind, and Strength™, you gain access to your full design. That is the power of Flow. It is not about perfect balance. It is about becoming integrated, aware, and equipped to lead and live with greater impact.</p>
            </div> 
            <p className="flow-results">YOUR FLOW RESULTS</p>
            <div className="image-container">
              {SquareWithArrow()}
            </div>
          </div>
        </div>
      </div>
      <FooterPreview reportType={reportType} pageNumber={pageNumber} />
    </div>
  );
}
